const getBackgroundImageOrigSource = (blockNode) => {
  const backgroundContainer = blockNode.querySelector('ws-background-container');
  return backgroundContainer && backgroundContainer.origSrc;
};

export default getBackgroundImageOrigSource;
